import { useState } from "react";
import { Phone, Video } from "lucide-react";
export default function SpeakToRealPerson() {
  const [hoveredCard, setHoveredCard] = useState<number | null>(null);
  return <section style={{
    backgroundColor: "rgb(255, 255, 255)",
    backgroundPosition: "0% 0%",
    backgroundRepeat: "repeat",
    color: "rgb(42, 45, 43)",
    fontFamily: 'ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"',
    paddingTop: "96px",
    paddingBottom: "96px",
    animation: "none 0s ease 0s 1 normal none running"
  }}>
      <div className="page-container">
        <div className="flex flex-col md:flex-row gap-12 md:gap-20 items-center">

          
          <div className="w-full md:w-2/5 flex-shrink-0" style={{
          background: "rgb(249, 248, 244)",
          borderRadius: "16px",
          padding: "40px",
          boxShadow: "rgba(0,0,0,0.06) 0px 4px 24px"
        }}>
            
            <div className="flex justify-center relative" style={{
            width: "88px",
            marginBottom: "0"
          }}>
              <div className="relative">
                <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1694540/img/sarah-jenkins-headshot-HJUXj5VJvrJhJiPXTJf2YU.webp" alt="Sarah Jenkins - Spa Revenue Specialist" className="rounded-full object-cover" style={{
                width: "88px",
                height: "88px",
                border: "3px solid white"
              }} />
                <span className="absolute" style={{
                width: "12px",
                height: "12px",
                backgroundColor: "rgb(34, 197, 94)",
                borderRadius: "50%",
                bottom: "2px",
                right: "2px",
                border: "2px solid white"
              }} />
              </div>
            </div>

            
            <div className="flex flex-row items-center gap-2 mt-4 flex-wrap">
              <span style={{
              fontFamily: "ui-serif, Georgia, Cambria, \"Times New Roman\", Times, serif",
              fontSize: "20px",
              fontWeight: "700",
              color: "rgb(31, 58, 46)"
            }}>
                Sarah Jenkins
              </span>
              <span style={{
              fontSize: "10px",
              fontWeight: "600",
              letterSpacing: "0.05em",
              color: "rgb(31, 58, 46)",
              backgroundColor: "rgb(220, 230, 225)",
              borderRadius: "20px",
              padding: "3px 8px",
              textTransform: "uppercase",
              whiteSpace: "nowrap"
            }}>
                VERIFIED SPECIALIST
              </span>
            </div>

            
            <p style={{
            color: "rgba(42, 45, 43, 0.6)",
            fontFamily: 'ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"',
            fontSize: "12px",
            fontWeight: "500",
            lineHeight: "16px",
            letterSpacing: "0.6px",
            border: "0px solid oklch(0.69 0.04 165 / 0.25)",
            textTransform: "uppercase",
            textAlign: "left",
            animation: "none 0s ease 0s 1 normal none running",
            marginTop: "4px"
          }}>
              SPA REVENUE SPECIALIST
            </p>

            
            <p style={{
            color: "rgba(42, 45, 43, 0.75)",
            fontFamily: 'ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"',
            fontSize: "14px",
            fontWeight: "400",
            lineHeight: "22.75px",
            border: "0px solid oklch(0.69 0.04 165 / 0.25)",
            textAlign: "left",
            animation: "none 0s ease 0s 1 normal none running",
            marginTop: "16px"
          }}>
              "Hi, I'm Sarah. I help spa owners configure their digital prepayment systems to match their physical spa branding. I can answer any questions, configure custom templates, or guide you through integration."
            </p>

            
            <div className="flex flex-row items-center gap-2 mt-6">
              <span style={{
              color: "rgb(31, 58, 46)",
              opacity: 0.6,
              display: "flex",
              alignItems: "center"
            }}>
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z"></path>
                  <path d="m9 12 2 2 4-4"></path>
                </svg>
              </span>
              <span style={{
              color: "rgba(42, 45, 43, 0.7)",
              fontFamily: 'ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"',
              fontSize: "14px",
              fontWeight: "400",
              lineHeight: "20px",
              border: "0px solid oklch(0.69 0.04 165 / 0.25)",
              animation: "none 0s ease 0s 1 normal none running"
            }}>
                No-Obligation Consultation
              </span>
            </div>
          </div>

          
          <div className="w-full md:w-3/5">
            
            <p style={{
            color: "#C8985C",
            fontFamily: 'ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"',
            fontSize: "12px",
            fontWeight: "500",
            lineHeight: "16px",
            letterSpacing: "0.6px",
            border: "0px solid oklch(0.69 0.04 165 / 0.25)",
            textTransform: "uppercase",
            textAlign: "left",
            animation: "none 0s ease 0s 1 normal none running",
            marginBottom: "12px"
          }}>
              HUMAN TRUST PORTAL
            </p>

            
            <h2 style={{
            color: "rgb(31, 58, 46)",
            fontFamily: 'ui-serif, Georgia, Cambria, "Times New Roman", Times, serif',
            fontSize: "36px",
            fontWeight: "400",
            lineHeight: "40px",
            border: "0px solid oklch(0.69 0.04 165 / 0.25)",
            animation: "none 0s ease 0s 1 normal none running"
          }}>
              Speak to a{" "}
              <em style={{
              color: "#C8985C",
              fontStyle: "italic"
            }}>Real Person</em>
              {" "}Today
            </h2>

            
            <p style={{
            color: "rgba(42, 45, 43, 0.75)",
            fontFamily: 'ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"',
            fontSize: "14px",
            fontWeight: "400",
            lineHeight: "22.75px",
            border: "0px solid oklch(0.69 0.04 165 / 0.25)",
            textAlign: "left",
            animation: "none 0s ease 0s 1 normal none running",
            marginTop: "16px",
            maxWidth: "480px"
          }}>
              Prefer a human touch? We understand. Schedule a 10-minute consultation with Sarah Jenkins. Fully transparent, absolutely zero pressure.
            </p>

            
            <div className="flex flex-col sm:flex-row gap-4 mt-8 flex-wrap">

              
              <button onMouseEnter={() => setHoveredCard(0)} onMouseLeave={() => setHoveredCard(null)} style={{
              color: "rgb(42, 45, 43)",
              fontFamily: 'ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"',
              fontSize: "16px",
              fontWeight: "400",
              lineHeight: "24px",
              backgroundColor: "rgb(255, 255, 255)",
              borderRadius: "16px",
              border: "1px solid rgba(31, 58, 46, 0.05)",
              padding: "24px",
              textAlign: "left",
              animation: "none 0s ease 0s 1 normal none running",
              width: "169px",
              minHeight: "150px",
              cursor: "pointer",
              transition: "box-shadow 0.3s cubic-bezier(0.4, 0, 0.2, 1), transform 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
              boxShadow: hoveredCard === 0 ? "rgba(0,0,0,0.12) 0px 8px 24px" : "rgba(0,0,0,0.04) 0px 2px 8px",
              transform: hoveredCard === 0 ? "translateY(-2px)" : "none",
              display: "flex",
              flexDirection: "column",
              alignItems: "flex-start"
            }}>
                <div style={{
                width: "40px",
                height: "40px",
                backgroundColor: "rgb(240, 245, 242)",
                borderRadius: "50%",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                marginBottom: "12px"
              }}>
                  <span style={{
                  color: "rgb(100, 150, 120)",
                  display: "flex"
                }}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                      <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"></path>
                    </svg>
                  </span>
                </div>
                <div style={{
                fontWeight: "400",
                fontSize: "16px",
                lineHeight: "24px",
                color: "rgb(42, 45, 43)"
              }}>Phone Call</div>
                <div style={{
                fontSize: "14px",
                fontWeight: "400",
                color: "rgba(42, 45, 43, 0.6)",
                marginTop: "4px"
              }}>10-Min Audio Call</div>
              </button>

              
              <button onMouseEnter={() => setHoveredCard(1)} onMouseLeave={() => setHoveredCard(null)} style={{
              color: "rgb(42, 45, 43)",
              fontFamily: 'ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"',
              fontSize: "16px",
              fontWeight: "400",
              lineHeight: "24px",
              backgroundColor: "rgb(255, 255, 255)",
              borderRadius: "16px",
              border: "1px solid rgba(31, 58, 46, 0.05)",
              padding: "24px",
              textAlign: "left",
              animation: "none 0s ease 0s 1 normal none running",
              width: "169px",
              minHeight: "150px",
              cursor: "pointer",
              transition: "box-shadow 0.3s cubic-bezier(0.4, 0, 0.2, 1), transform 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
              boxShadow: hoveredCard === 1 ? "rgba(0,0,0,0.12) 0px 8px 24px" : "rgba(0,0,0,0.04) 0px 2px 8px",
              transform: hoveredCard === 1 ? "translateY(-2px)" : "none",
              display: "flex",
              flexDirection: "column",
              alignItems: "flex-start"
            }}>
                <div style={{
                width: "40px",
                height: "40px",
                backgroundColor: "rgb(240, 245, 242)",
                borderRadius: "50%",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                marginBottom: "12px"
              }}>
                  <span style={{
                  color: "rgb(100, 130, 160)",
                  display: "flex"
                }}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                      <path d="m16 13 5.223 3.482a.5.5 0 0 0 .777-.416V7.87a.5.5 0 0 0-.752-.432L16 10.5"></path>
                      <rect x="2" y="6" width="14" height="12" rx="2"></rect>
                    </svg>
                  </span>
                </div>
                <div style={{
                fontWeight: "400",
                fontSize: "16px",
                lineHeight: "24px",
                color: "rgb(42, 45, 43)"
              }}>Zoom Meeting</div>
                <div style={{
                fontSize: "14px",
                fontWeight: "400",
                color: "rgba(42, 45, 43, 0.6)",
                marginTop: "4px"
              }}>10-Min Video Call</div>
              </button>

              
              <button onMouseEnter={() => setHoveredCard(2)} onMouseLeave={() => setHoveredCard(null)} style={{
              color: "rgb(42, 45, 43)",
              fontFamily: 'ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"',
              fontSize: "16px",
              fontWeight: "400",
              lineHeight: "24px",
              backgroundColor: "rgb(255, 255, 255)",
              borderRadius: "16px",
              border: "1px solid rgba(31, 58, 46, 0.05)",
              padding: "24px",
              textAlign: "left",
              animation: "none 0s ease 0s 1 normal none running",
              width: "169px",
              minHeight: "150px",
              cursor: "pointer",
              transition: "box-shadow 0.3s cubic-bezier(0.4, 0, 0.2, 1), transform 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
              boxShadow: hoveredCard === 2 ? "rgba(0,0,0,0.12) 0px 8px 24px" : "rgba(0,0,0,0.04) 0px 2px 8px",
              transform: hoveredCard === 2 ? "translateY(-2px)" : "none",
              display: "flex",
              flexDirection: "column",
              alignItems: "flex-start"
            }}>
                <div style={{
                width: "40px",
                height: "40px",
                backgroundColor: "rgb(240, 245, 242)",
                borderRadius: "50%",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                marginBottom: "12px"
              }}>
                  <span style={{
                  color: "#C8985C",
                  display: "flex"
                }}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                      <path d="M8 2v4"></path>
                      <path d="M16 2v4"></path>
                      <rect width="18" height="18" x="3" y="4" rx="2"></rect>
                      <path d="M3 10h18"></path>
                    </svg>
                  </span>
                </div>
                <div style={{
                fontWeight: "400",
                fontSize: "16px",
                lineHeight: "24px",
                color: "rgb(42, 45, 43)"
              }}>Google Meet</div>
                <div style={{
                fontSize: "14px",
                fontWeight: "400",
                color: "rgba(42, 45, 43, 0.6)",
                marginTop: "4px"
              }}>10-Min Video Call</div>
              </button>
            </div>

            
            <div className="flex flex-row items-center flex-wrap gap-3 mt-6">
              <span style={{
              color: "rgb(31, 58, 46)",
              opacity: 0.5,
              display: "flex",
              alignItems: "center"
            }}>
                <svg xmlns="http://www.w3.org/2000/svg" width="19" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z"></path>
                  <path d="m9 12 2 2 4-4"></path>
                </svg>
              </span>
              <span style={{
              color: "rgba(42, 45, 43, 0.7)",
              fontSize: "12px",
              fontWeight: "500",
              lineHeight: "16px",
              fontFamily: 'ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"'
            }}>
                Anti-Fraud Verified<br />Network
              </span>
              <span style={{
              color: "rgba(42, 45, 43, 0.4)",
              fontSize: "12px"
            }}>•</span>
              <span style={{
              color: "rgba(42, 45, 43, 0.5)",
              fontSize: "11px",
              fontWeight: "500",
              letterSpacing: "0.5px",
              textTransform: "uppercase",
              fontFamily: 'ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"'
            }}>
                PCI<br />COMPLIANT
              </span>
              <span style={{
              color: "rgba(42, 45, 43, 0.4)",
              fontSize: "12px"
            }}>•</span>
              <span style={{
              color: "rgba(42, 45, 43, 0.5)",
              fontSize: "11px",
              fontWeight: "500",
              letterSpacing: "0.5px",
              textTransform: "uppercase",
              fontFamily: 'ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"'
            }}>
                BANK-LEVEL<br />SECURITY
              </span>
              <span style={{
              color: "rgba(42, 45, 43, 0.4)",
              fontSize: "12px"
            }}>•</span>
              <span style={{
              color: "rgba(42, 45, 43, 0.5)",
              fontSize: "11px",
              fontWeight: "500",
              letterSpacing: "0.5px",
              textTransform: "uppercase",
              fontFamily: 'ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"'
            }}>
                SSL<br />ENCRYPTED
              </span>
            </div>
          </div>

        </div>
      </div>
    </section>;
}